
import { useState } from 'react';
import { SidebarProps } from './sidebar/types';
import { navItems } from './sidebar/navItems';
import Navigation from './sidebar/Navigation';
import SidebarFooter from './sidebar/SidebarFooter';
import BottomNavigation from './sidebar/BottomNavigation';
import CreatePostButton from './sidebar/CreatePostButton';
import { ChevronsLeft } from 'lucide-react';
import CollapsedSidebar from './sidebar/CollapsedSidebar';

const CustomSidebar = ({
  userName,
  activePage,
  setActivePage,
  handleSignOut,
  handleInviteUser
}: SidebarProps) => {
  const [expandedSections, setExpandedSections] = useState({
    publication: true,
    analytics: true,
    'online-store': true,
    'social-media': true
  });
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSection = (section: 'publication' | 'analytics' | 'online-store' | 'social-media') => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  // Update the navItems with the expanded state
  const navItemsWithState = navItems.map(item => {
    if (item.isExpandable) {
      return {
        ...item,
        isExpanded: expandedSections[item.id as 'publication' | 'analytics' | 'online-store' | 'social-media']
      };
    }
    return item;
  });

  if (isCollapsed) {
    return <CollapsedSidebar activePage={activePage} setActivePage={setActivePage} setIsCollapsed={setIsCollapsed} />;
  }

  return <div className="h-full w-64 bg-white dark:bg-[#121624] border-r border-gray-200 dark:border-[rgba(60,63,84,0.6)] flex flex-col transition-colors shadow-sm dashboard-sidebar">
      {/* Logo and Collapse Button */}
      <div className="px-6 py-6 border-b border-gray-200 dark:border-[rgba(60,63,84,0.6)] flex justify-between items-center">
        <h1 className="text-xl font-bold text-custom-primary dark:text-custom-secondaryLight text-left">
          <img src="/lovable-uploads/60f073cd-316e-4fa1-9add-c6553bdb9ac9.png" alt="Scaloo" className="h-8" />
        </h1>
        <button onClick={() => setIsCollapsed(true)} className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300" aria-label="Réduire le panneau">
          <ChevronsLeft className="h-5 w-5" />
        </button>
      </div>
      
      {/* Navigation */}
      <Navigation 
        navItems={navItemsWithState} 
        activePage={activePage} 
        setActivePage={setActivePage} 
        toggleSection={toggleSection} 
      />
      
      {/* Create Post Button */}
      <CreatePostButton />

      {/* Bottom Navigation */}
      <BottomNavigation handleInviteUser={handleInviteUser} />
      
      {/* User footer */}
      <SidebarFooter userName={userName} handleSignOut={handleSignOut} />
    </div>;
};

export default CustomSidebar;
